// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"574":"onboarding_chunk","866":"admin_chunk"}[chunkId] || chunkId) + "." + {"451":"f2ee544a","574":"cc3984e4","866":"d05a0384","910":"f1ee101c"}[chunkId] + ".chunk.js";
};